export const Data = {
    state: {
        companyForms: [
            'AG',
            'GmbH',
            'mbH',
            'Ltd.',
            'KGaA',
            'OHG',
            'e. K.',
            'PartG',
            'KG',
            'Einzelunternehmen',
            'GbR',
            'GmbH & Co. KG',
            'AG & Co. KG',
            'e. V.',
            'e. G.',
            'Stiftung',
            'KdöR',
            'AdöR',
            'SA',
            'EWIV',
            'AE',
            'UG'
        ],
        countries: ['Deutschland', 'Österreich', 'Schweiz'],
        registryCourts: [
            'Amtsgericht Aachen',
            'Amtsgericht Amberg',
            'Amtsgericht Ansbach',
            'Amtsgericht Arnsberg',
            'Amtsgericht Aschaffenburg',
            'Amtsgericht Augsburg',
            'Amtsgericht Aurich',
            'Amtsgericht Bad Hersfeld',
            'Amtsgericht Bad Homburg v. d. Höhe',
            'Amtsgericht Bad Kreuznach',
            'Amtsgericht Bad Oeynhausen',
            'Amtsgericht Bamberg',
            'Amtsgericht Bayreuth',
            'Amtsgericht Berlin-Charlottenburg',
            'Amtsgericht Bielefeld',
            'Amtsgericht Bochum',
            'Amtsgericht Bonn',
            'Amtsgericht Braunschweig',
            'Amtsgericht Bremen',
            'Amtsgericht Chemnitz',
            'Amtsgericht Coburg',
            'Amtsgericht Coesfeld',
            'Amtsgericht Cottbus',
            'Amtsgericht Darmstadt',
            'Amtsgericht Deggendorf',
            'Amtsgericht Dortmund',
            'Amtsgericht Dresden',
            'Amtsgericht Duisburg',
            'Amtsgericht Düren',
            'Amtsgericht Düsseldorf',
            'Amtsgericht Eschwege',
            'Amtsgericht Essen',
            'Amtsgericht Flensburg',
            'Amtsgericht Frankfurt am Main',
            'Amtsgericht Frankfurt/Oder',
            'Amtsgericht Freiburg',
            'Amtsgericht Friedberg (Hessen)',
            'Amtsgericht Fritzlar',
            'Amtsgericht Fulda',
            'Amtsgericht Fürth (Bayern)',
            'Amtsgericht Gelsenkirchen',
            'Amtsgericht Gießen',
            'Amtsgericht Göttingen',
            'Amtsgericht Gütersloh',
            'Amtsgericht Hagen',
            'Amtsgericht Hamburg',
            'Amtsgericht Hamm',
            'Amtsgericht Hanau',
            'Amtsgericht Hannover',
            'Amtsgericht Hildesheim',
            'Amtsgericht Hof',
            'Amtsgericht Ingolstadt',
            'Amtsgericht Iserlohn',
            'Amtsgericht Jena',
            'Amtsgericht Kaiserslautern',
            'Amtsgericht Kassel',
            'Amtsgericht Kempten',
            'Amtsgericht Kiel',
            'Amtsgericht Kleve',
            'Amtsgericht Koblenz',
            'Amtsgericht Korbach',
            'Amtsgericht Krefeld',
            'Amtsgericht Köln',
            'Amtsgericht Königstein',
            'Amtsgericht Landau in der Pfalz',
            'Amtsgericht Landshut',
            'Amtsgericht Leipzig',
            'Amtsgericht Lemgo',
            'Amtsgericht Limburg',
            'Amtsgericht Ludwigshafen am Rhein',
            'Amtsgericht Lübeck',
            'Amtsgericht Lüneburg',
            'Amtsgericht Mainz',
            'Amtsgericht Mannheim',
            'Amtsgericht Marburg',
            'Amtsgericht Memmingen',
            'Amtsgericht Montabaur',
            'Amtsgericht Mönchengladbach',
            'Amtsgericht München',
            'Amtsgericht Münster',
            'Amtsgericht Neubrandenburg',
            'Amtsgericht Neuruppin',
            'Amtsgericht Neuss',
            'Amtsgericht Nürnberg',
            'Amtsgericht Offenbach am Main',
            'Amtsgericht Oldenburg',
            'Amtsgericht Osnabrück',
            'Amtsgericht Paderborn',
            'Amtsgericht Passau',
            'Amtsgericht Pinneberg',
            'Amtsgericht Potsdam',
            'Amtsgericht Recklinghausen',
            'Amtsgericht Regensburg',
            'Amtsgericht Rostock',
            'Amtsgericht Saarbrücken',
            'Amtsgericht Schweinfurt',
            'Amtsgericht Schwerin',
            'Amtsgericht Siegburg',
            'Amtsgericht Siegen',
            'Amtsgericht Stadthagen',
            'Amtsgericht Steinfurt',
            'Amtsgericht Stendal',
            'Amtsgericht Stralsund',
            'Amtsgericht Straubing',
            'Amtsgericht Stuttgart',
            'Amtsgericht Tostedt',
            'Amtsgericht Traunstein',
            'Amtsgericht Ulm',
            'Amtsgericht Walsrode',
            'Amtsgericht Wetzlar',
            'Amtsgericht Wiesbaden',
            'Amtsgericht Wittlich',
            'Amtsgericht Wuppertal',
            'Amtsgericht Zweibrücken'
        ]
    },
    mutations: {},
    getters: {},
    actions: {}
};
